!function () { function e(e, n) { n = n || { bubbles: !1, cancelable: !1, composed: !1 }; var t = document.createEvent("Event"); return t.initEvent(e, n.bubbles, n.cancelable, n.detail), t } "function" != typeof window.Event && (e.prototype = window.Event.prototype, window.Event = e) }();
export var SimulatorHelper = async function (elements, configuration) {
    var urlFormSim;
    var urlFormSimFly;
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var urlSimParam;
    var ignoreCookie = false;
    var enableTrakSlider = false;
    var productType = "prestiti";
    var eventSlider = "input";
    var enableScrollTacking = false;
    var withOffer = false;
    var currentValue = {
        rate: "",
        amount: ""
    };
    var stikyValue = {
        rate: configuration.IMPORTO_INIZIALE,
        amount: configuration.RATA_INIZIALE
    };
    if (isIE)
        eventSlider = "change";


    var simulator;
    var el = elements;
    var config = configuration;
    if (typeof config.productType !== "undefined")
        productType = config.productType;
    if (typeof config.ignoreCookie !== "undefined")
        ignoreCookie = config.ignoreCookie;
    var rootDomain = getRootDomain(document.location.hostname);
    if (typeof config.helperSim !== "undefined") {
        if (config.helperSim.indexOf("?") < 0)
            config.helperSim = config.helperSim + "?";
        else if (!config.helperSim.endsWith("?") && !config.helperSim.endsWith("&"))
            config.helperSim = config.helperSim + "&";
    }

    if (ignoreCookie == false) {
        if (typeof readCookie === "undefined")
            window.readCookie = function (name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            };
        if (typeof setCookieWithDomain === "undefined")
            window.setCookieWithDomain = function (n, t, i, r) {
                var u = new Date,
                    f;
                u.setTime(u.getTime() + i * 864e5);
                f = "expires=" + u.toGMTString();
                document.cookie = n + "=" + t + "; " + f + "; path=/;domain=" + r;
            };
    }
    if (typeof replaceAll === "undefined") {
        String.prototype.replaceAll = function (search, replacement) {
            return this.replace(new RegExp(search, 'g'), replacement);
        };
    }
    if (typeof CurrencyFormat === "undefined") {
        String.prototype.CurrencyFormat = function (n) {
            var r = 0,
                t = this,
                f = "",
                e = !1,
                u, o, s, i;
            if (typeof n !== "undefined" && parseInt(n) > 0 && (r = parseInt(n)), u = t.split(","), u.length > 1 && (t = u[0], f = u[1], r -= f.length, e = !0), t.length > 3 && t.indexOf(".") < 0 && (o = this.substring(t.length - 3, t.length), s = this.substring(0, t.length - 3), t = s + "." + o), r > 0 || e)
                for (t += "," + f, i = 0; i < r; i++) t += "0";
            return t;
        };
    }

    function checkIfValidNumber(n) {
        return typeof n !== "undefined" && typeof n === "number";
    }

    function getRootDomain(n) {
        var t = n.split("."),
            i;
        return t.length >= 3 ? (i = t.length, t[i - 1].length < 3 && t[i - 2].length <= 3 ? "." + t[i - 3] + "." + t[i - 2] + "." + t[i - 1] : "." + t[i - 2] + "." + t[i - 1]) : n
    }

    function callTrack(n) {
        n.preventDefault();
        agos_data.assistenza = "numero verde";
        if (typeof _satellite !== "undefined")
            _satellite.track("chiama-ora");
        setTimeout(function () {
            location.href = document.getElementById("submit-chiama").href;
        }, 500);
    }

    function initSimulatore() {
        let simJson = document.querySelector(".plan-sim");
        let _loaded = false;
        let _sim = null;
        try {
            if (simJson != null) {
                _sim = JSON.parse(simJson.innerHTML);

            }
        }
        catch (err) {
            console.log(err);
        }


        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                simulator = JSON.parse(this.responseText);

                if (_sim != null)
                    simulator.Simulatore = _sim;
                else
                    simulator.Simulatore = JSON.parse(simulator.Simulatore);

                //el.placeholder.style.display = "none";
                //el.simulatorContainer.style.display = "block";
                el.sliderAmount.addEventListener(eventSlider, function () {
                    onSlide(el.sliderAmount, el.sliderAmountFiller);
                });
                el.sliderRate.addEventListener(eventSlider, function () {
                    onSlide(el.sliderRate, el.sliderRateFiller);
                });

                el.sliderAmount.removeAttribute("disabled");
                el.sliderRate.removeAttribute("disabled");

                el.sliderAmount.dispatchEvent(new Event(eventSlider));
                el.sliderRate.dispatchEvent(new Event(eventSlider));

                //if (simulator.Simulatore && el.minImport) {
                //    el.minImport.innerHTML = simulator.Simulatore.Erogato[0].Importo + "€";
                //}

                //if (simulator.Simulatore && el.maxImport) {
                //    el.maxImport.innerHTML = simulator.Simulatore.Erogato[simulator.Simulatore.Erogato.length - 1].Importo.toString().CurrencyFormat(0) + "€";
                //}

                enableTrakSlider = true;

                el.cta.addEventListener("click", goToSimulator);

                waitForDOM('complete').then(() => {
                    if (el.stickyhref)
                        el.stickyhref.addEventListener("click", goToSimulatorStiky);
                });
              

                if (isIE)
                    setTimeout(function () {
                        el.sliderAmount.dispatchEvent(new Event(eventSlider));
                        el.sliderRate.dispatchEvent(new Event(eventSlider));
                        setTimeout(function () { enableScrollTacking = true; }, 500);
                    }, 500);
                else
                    enableScrollTacking = true;
            }
            else if (xhttp.readyState === 4)
                console.log(xhttp);
        };

        xhttp.open("GET", config.helperSim + "jsontype=all");
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.send();

        withOffer = document.querySelector(`div.cnt-offer-rsume`) != null;
      
    }

    function waitForDOM(type = 'interactive') {
        return new Promise((resolve) => {
            const checkState = () => {
                if (type === 'complete') {
                    return document.readyState === 'complete';
                }
                return document.readyState !== 'loading';
            };

            if (checkState()) {
                resolve();
            } else {
                const event = type === 'complete' ? 'load' : 'DOMContentLoaded';
                const target = type === 'complete' ? window : document;
                target.addEventListener(event, resolve, { once: true });
            }
        });
    }
    function setAllValue(elementsArray, value) {

        if (!elementsArray)
            return;
        for (var xi = 0; xi < elementsArray.length; xi++) {
            elementsArray[xi].innerHTML = value;
        }
    }

    function updateDisclaimer(rate, amount) {

        var n = rate, t = amount;
        var txRata = n.Text,
            txDurata = n.Durata,
            txTan = n.Tan,
            txTaeg = n.Taeg,
            txImporto = t.Importo.toString().CurrencyFormat(2);
        currentValue.amount = t.Importo.toString();
        currentValue.rate = txDurata;
        if (el.sticky) {
            el.sticky.innerHTML = "<span>" + txImporto + "€ in " + txDurata + " rate da " + txRata + "€</span><span> tan " + txTan + " taeg " + txTaeg + "</span>";
            stikyValue = currentValue;
        }
        if (document.querySelector("div.cnt-offer-rsume")) {
            setAllValue(el.tan, txTan);
            setAllValue(el.taeg, txTaeg);
            setAllValue(el.stikyimporto, txImporto + "€");
            setAllValue(el.stikyrata, txRata + "€");
            if (!el.disclaimer)
                el.disclaimer = document.getElementById("disclaimer");
        }


        if (typeof simulator !== "undefined" && typeof simulator.Disclaimer !== "undefined" && el.disclaimer) {

            var variableToReplace = [
                { r: "$Text$", v: txRata },
                { r: "$Rata$", v: txDurata },
                { r: "$ImportoRata$", v: txRata },
                { r: "$tan$", v: txTan.replace("%", "") },
                { r: "$taeg$", v: txTaeg.replace("%", "") },
                { r: "$totaledovuto$", v: n.Totdov },
                { r: "$bollo$", v: parseFloat(n.Impostabollo.replace(',', '.')).toFixed(2).toString().replace('.', ',') },
                { r: "$Istruttoria$", v: n.Istruttoria },
                { r: "$gestione$", v: parseFloat(n.Spesapratica.replace(',', '.')).toFixed(2).toString().replace('.', ',') },
                { r: "$Offerta$", v: txImporto },
                { r: "$FineRapporto$", v: parseFloat(n.Impostarendicontoannuale.replace(',', '.')).toFixed(2).toString().replace('.', ',') },
                { r: "$Importo$", v: txImporto },
                { r: "$TxtBollo$", v: n.TextBollo }];

            var disclaimer = simulator.Disclaimer;
            for (var xi = 0; xi < variableToReplace.length; xi++) {
                do {
                    disclaimer = disclaimer.replace(variableToReplace[xi].r, variableToReplace[xi].v);
                } while (disclaimer.indexOf(variableToReplace[xi].r) >= 0);
            }

            el.disclaimer.innerHTML = disclaimer;

        }

        if (ignoreCookie == false) {
            setCookieWithDomain("a_num_rate", n.Durata, 30, rootDomain);
            setCookieWithDomain("a_importo", t.Importo.toString(), 30, rootDomain);
        }
        _updateUrlUtility.setUrlParams(t.Importo, n.Durata);
    }

    function IsOverlayOrNotIsPresent() {
        return el.otherSlider || !document.getElementById("mmm-ovr-sim");
    }
    function onSlide(element, filler) {
        if (enableTrakSlider == true &&
            enableScrollTacking == true && IsOverlayOrNotIsPresent()) {
            try {
                if (typeof _satellite !== "undefined")
                    _satellite.track('simulatore-' + productType + '-scroll');
            }
            catch (ex) {
                console.log(ex);
            }
            enableTrakSlider = false;
        }
        //var max = parseInt(element.max) - parseInt(element.min);
        //var index = element.value;
        //var percent = parseInt((index / max) * 100);
        //if (percent > 95) percent -= 5;
        //// if (percent < 5) percent += 5;
        //filler.style.width = percent + '%';
        setDivWidth(element, filler);
        slideChangeUpdateValue();
    }

    function setDivWidth(element, filler) {
        var max = parseInt(element.max) - parseInt(element.min);
        var index = element.value;
        var percent = parseInt((index / max) * 100);
        //if (percent > 95) percent -= 5;
        //  if (percent < 15) percent += 4;
        if (percent < 40) {
            //if (percent > 18 || percent<10)
            percent += 2;
        }
        filler.style.width = percent + '%';
    }
    function changeValueAndTriggerEvent(index, rateIndex) {

        try {
            if (el.otherSlider.sliderAmount) {
                el.otherSlider.sliderAmount.value = index;
            }
            if (el.otherSlider.sliderRate) {
                el.otherSlider.sliderRate.value = rateIndex;
            }

            if (el.otherSlider.sliderAmount) {
                el.otherSlider.sliderAmount.dispatchEvent(new Event(eventSlider));

            }
            if (el.otherSlider.sliderRate) {
                el.otherSlider.sliderRate.dispatchEvent(new Event(eventSlider));

            }
        }
        catch (e) {
            console.log(e);
        }
    }

    function slideChangeUpdateValue() {
        var index = el.sliderAmount.value;
        var amount = simulator.Simulatore.Erogato[index];
        var rateIndex = el.sliderRate.value;
        var rate;
        var valueText = "DATI DELLA SIMULAZIONE: ";
        if (rateIndex >= amount.Durata.Rata.length)
            rateIndex = parseInt(amount.Durata.Rata.length / 2);
        rate = amount.Durata.Rata[rateIndex];
        el.valueimporto.innerHTML = amount.Importo.toString().CurrencyFormat(0);
        el.valuerata.innerHTML = rate.Durata;

        el.minrata.innerHTML = amount.Durata.Rata[0].Durata + " rate";
        el.maxrata.innerHTML = amount.Durata.Rata[amount.Durata.Rata.length - 1].Durata + " rate";


        el.sliderAmount.setAttribute("aria-valuenow", amount.Importo.toString());




        updateSliderRate(rateIndex, amount.Durata.Rata.length, rate, amount);
        el.sliderRate.setAttribute("aria-valuenow", rate.Durata);
        el.sliderRate.setAttribute("aria-valuemin", amount.Durata.Rata[0].Durata);
        el.sliderRate.setAttribute("aria-valuemax", amount.Durata.Rata[amount.Durata.Rata.length - 1].Durata);

        valueText += amount.Importo.toString().CurrencyFormat(2).replace('.', '') + " € in " + rate.Durata + " Rate";
        if (withOffer == true) {
            valueText += " da " + rate.Text.replace('.', '') + " € TAN " + rate.Tan + " TAEG " + rate.Taeg;
        }

        el.sliderAmount.setAttribute("aria-valuetext", valueText);
        el.sliderRate.setAttribute("aria-valuetext", valueText);



        if (el.otherSlider) {
            changeValueAndTriggerEvent(index, rateIndex);
        }

        document.dispatchEvent(new CustomEvent('offer_value_changed_event', {
            detail: {
                loan: amount.Importo,
                splits: rate.Durata,
                tan: rate.Tan,
                taeg: rate.Taeg,
                installment: rate.Text,
                startUrl: el.cta.href,
            }
        }));
    }

    function updateSliderRate(index, rateLength, rate, amount) {
        el.sliderRate.max = rateLength - 1;
        el.sliderRate.value = index;

        setDivWidth(el.sliderRate, el.sliderRateFiller);
        updateDisclaimer(rate, amount);
    }

    function goToSimulator(e) {
        e.preventDefault();
        try {
            agos_data.importo_prestito = currentValue.amount;
            agos_data.numero_rate = currentValue.rate;
            if (typeof _satellite !== "undefined") {
                if (e.target.closest('#mmm-ovr-sim-green') != null) {
                    _satellite.track('simulatore-' + productType + '-richiedi', { position: "banner prestiti overlay", importo_prestito: currentValue.amount, numero_rate: currentValue.rate });
                    console.log(`simulatore-${productType}-richiedi', { position: "banner prestiti overlay", importo_prestito: ${stikyValue.amount}, numero_rate: ${stikyValue.rate}`);
                }
                else {
                    var pos = document.querySelector('.breadcrumbs') != null ? "in page" : "banner";;
                    _satellite.track('simulatore-' + productType + '-richiedi', { position: pos, importo_prestito: currentValue.amount, numero_rate: currentValue.rate });

                    console.log(`simulatore-${productType}-richiedi', { position: ${pos}, importo_prestito: ${currentValue.amount}, numero_rate: ${currentValue.rate}}`);
                }
            }
        }
        catch (ex) {
            console.log(ex);
        }
        window.open(urlSimParam, '_blank');
        // location.href = urlSimParam;
    }

    function goToSimulatorStiky(e) {
        e.preventDefault();
        try {
            agos_data.importo_prestito = stikyValue.amount;
            agos_data.numero_rate = stikyValue.rate;
            agos_data.position = 'header bar';
            if (typeof _satellite !== "undefined") {

                _satellite.track('simulatore-' + productType + '-richiedi', { position: "bottom bar", importo_prestito: stikyValue.amount, numero_rate: stikyValue.rate });
                console.log(`simulatore-${productType}-richiedi', { position: "bottom bar", importo_prestito: ${stikyValue.amount}, numero_rate: ${stikyValue.rate}`);
            }
        }
        catch (ex) {
            console.log(ex);
        }
        window.open(el.stickyhref.href, '_blank');
        //location.href = el.stickyhref.href;
    }

    var _updateUrlUtility = (function () {
        urlFormSim = config.redirect;
        if (el.stickyhref && el.stickyhref.href) {
            urlFormSimFly = el.stickyhref.href;
        }

        function removeDataFromQuery(urlValue) {
            var tmpUrl = decodeURIComponent(urlValue);
            var baseTmpUrl = tmpUrl.split('?')[0] + "?";
            if (tmpUrl.split('?').length > 1) {
                try {
                    var queryUrl = tmpUrl.split('?')[1].split('&');
                    var isFirst = true;
                    for (var par = 0; par < queryUrl.length; par++) {
                        if (queryUrl[par].indexOf("am=") < 0 && queryUrl[par].indexOf("nr=") < 0) {
                            if (isFirst == false)
                                baseTmpUrl += "&";
                            baseTmpUrl += queryUrl[par];
                            isFirst = false;
                        }
                    }
                }
                catch { }
            }
            return baseTmpUrl;
        }
        function updateUrl(newUrl) {
            if (typeof newUrl !== "undefined" && newUrl !== null && newUrl !== "") {
                /*   if (newUrl.indexOf('?') >= 0 || newUrl.indexOf('/') >= 0)
                       newUrl = encodeURIComponent(newUrl);*/

                urlFormSim = newUrl;
                // urlFormSimFly = removeDataFromQuery(newUrl);
                el.sliderAmount.dispatchEvent(new Event(eventSlider));
            }
        }
        function removeURLParameter(url, pq) {

            //prefer to use l.search if you have a location/link object
            var urlparts = url.split('?');
            if (urlparts.length >= 2) {

                var prefix = encodeURIComponent(pq) + '=';
                var pars = urlparts[1].split(/[&;]/g);

                //reverse iteration as may be destructive
                for (var i = pars.length; i-- > 0;) {
                    //idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }

                return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            }
            return url;
        }

        function setUrlParams(n, t) {
            var url = removeURLParameter(urlFormSim, 'am');
            url = removeURLParameter(url, 'nr');
            if (config.weboramaTraceUrl && config.weboramaTraceUrl.trim() != "") {
                var i = Math.round(Math.random() * 1e7);
                urlSimParam = config.weboramaTraceUrl + i + "&g.lu=" + url + "%26am%3D" + n + "%2C00%26nr%3D" + t;
            }
            else {
                urlSimParam = url + "&am=" + n + "&nr=" + t;
            }
            el.cta.href = urlSimParam;
            if (el.stickyhref) {
                el.stickyhref.href = urlFormSimFly + "&am=" + n + "&nr=" + t;
            }
        }
        return {
            updateUrl: updateUrl,
            setUrlParams: setUrlParams
        };
    })();

    initSimulatore();
    return {
        updateUrl: _updateUrlUtility.updateUrl,
        goToSimulator: goToSimulator,
        callTrack: callTrack
    };
};